import {
    FETCH_PERMISSION_REQUEST,
    FETCH_PERMISSION_SUCCESS,
    FETCH_PERMISSION_FAILURE,
  } from "./FetchPermissionsTypes";
  import api from "../../utils/Api";
  
  export const fetchPermissionsRequest = () => {
    return {
      type: FETCH_PERMISSION_REQUEST,
    };
  };
  
  export const fetchPermissionsSuccess = (permissionsData) => {
    return {
      type: FETCH_PERMISSION_SUCCESS,
      payload: permissionsData,
    };
  };
  
  export const fetchPermissionsFailure = (error) => {
    return {
      type: FETCH_PERMISSION_FAILURE,
      payload: error,
    };
  };
  
  export const fetchPermissions = (role_id) => {
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
    let url = "user/role/detail/fetch?role_id=" + role_id;
    
    return async (dispatch) => {
      dispatch(fetchPermissionsRequest());
      try {
        const response = await api.get(url,
          {
            headers: headers,
          }
        );
        const permissionsData = response.data.data;
        //console.log("****** permissions list response", permissionsData);
        dispatch(fetchPermissionsSuccess(permissionsData));
      } catch (error) {
        console.log("Redux error - ", error.response);
        const errorMsg = error.message;
        dispatch(fetchPermissionsFailure(errorMsg));
      }
    };
  };
  